import type { IServiceWorkerClient } from '../interface';
import type { IServiceWorkerController } from '../interface/controller';
import serviceWorker from './worker';

function controller(deps: Parameters<typeof serviceWorker>[0]): Promise<IServiceWorkerController> {
    let activeWorker: IServiceWorkerClient | null = null;

    return Promise.resolve({
        start: (url: string, scope: string): IServiceWorkerClient => {
            deps.log.verbose('Starting Service-Worker');
            activeWorker?.stop();
            activeWorker = serviceWorker(deps, url, scope);
            activeWorker.start();
            return activeWorker;
        },
        active: (): IServiceWorkerClient | undefined => activeWorker ?? undefined,
        terminate: (): void => {
            deps.log.verbose('Terminating Service-Worker');
            activeWorker?.stop();
            activeWorker = null;
        },
    });
}

export default Object.freeze(controller);
